import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { AsyncDomainSelect } from './function';

export const AsyncDomainSelectFormField = FormFieldBlueprint.make({
  name: 'async-domain-select',
  params: {
    field: async () =>
      createFormField({
        name: 'AsyncDomainSelect',
        component: AsyncDomainSelect,
      }),
  },
});
